<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Location</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="description" class="col-md-2">Description *</label>
                  <div class="col-md-10">
                    <input
                      id="description"
                      v-model="entity.description"
                      type="text"
                      placeholder="Enter description"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="country" class="col-md-2">Country</label>
                  <div class="col-md-10">
                    <input
                      id="country"
                      v-model="entity.address.country"
                      type="text"
                      placeholder="Enter country"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="state" class="col-md-2">State</label>
                  <div class="col-md-10">
                    <input
                      id="state"
                      v-model="entity.address.state"
                      type="text"
                      placeholder="Enter state"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="city" class="col-md-2">City</label>
                  <div class="col-md-10">
                    <input
                      id="city"
                      v-model="entity.address.city"
                      type="text"
                      placeholder="Enter city"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="address" class="col-md-2">Address</label>
                  <div class="col-md-10">
                    <input
                      id="address"
                      v-model="entity.address.address"
                      type="text"
                      placeholder="Enter address"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="postal_code" class="col-md-2">Zip/Postal code</label>
                  <div class="col-md-10">
                    <input
                      id="postal_code"
                      v-model="entity.address.postal_code"
                      type="text"
                      placeholder="Enter postal code"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="organisation_name" class="col-md-2">Organisation name</label>
                  <div class="col-md-10">
                    <input
                      id="organisation_name"
                      v-model="entity.address.organisation_name"
                      type="text"
                      placeholder="Enter organisation name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="fax" class="col-md-2">Fax</label>
                  <div class="col-md-10">
                    <input
                      id="fax"
                      v-model="entity.contacts.fax"
                      type="text"
                      placeholder="Enter fax"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="email" class="col-md-2">Email</label>
                  <div class="col-md-10">
                    <input
                      id="email"
                      v-model="entity.contacts.email"
                      type="text"
                      placeholder="Enter email"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="phone" class="col-md-2">Phone</label>
                  <div class="col-md-10">
                    <input
                      id="phone"
                      v-model="entity.contacts.phone"
                      type="text"
                      placeholder="Enter phone"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="website" class="col-md-2">Website</label>
                  <div class="col-md-10">
                    <input
                      id="website"
                      v-model="entity.contacts.website"
                      type="text"
                      placeholder="Enter website"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Geocode</label>
                  <div class="col-md-5" style="margin-bottom: 1rem;">
                    <input
                      id="title"
                      v-model="entity.geocode.lat"
                      type="text"
                      placeholder="Enter latitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      id="title"
                      v-model="entity.geocode.lon"
                      type="text"
                      placeholder="Enter longitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <gmap-map
                      v-if="entity.geocode"
                      style="width: 100%; height:350px; margin-top: 20px;"
                      :center="mapCenter"
                      :zoom="mapZoom"
                      @click="mapClick"
                    >
                      <gmap-marker
                        :position="entityMapCenter"
                      />
                    </gmap-map>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Location has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'LocationNew',

  components: {
    referencer: Referencer,
    terms: Terms,
  },

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        title: null,
        description: null,
        address: {
          country: null,
          state: null,
          city: null,
          address: null,
          postal_code: null,
          organisation_name: null,
        },
        contacts: {
          fax: null,
          email: null,
          phone: null,
          website: null,
        },
        geocode: {
          lat: null,
          lon: null,
        },
        path_alias: '',
        seo_title: '',
        seo_description: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      mapZoom: 2,
    };
  },

  computed: {
    entityMapCenter() {
      if (this.entity.geocode === undefined || this.entity.geocode.lat == null || this.entity.geocode.lon == null) {
        return {
          lat: 0,
          lng: 0,
        };
      }
      return {
        lat: _.toNumber(this.entity.geocode.lat),
        lng: _.toNumber(this.entity.geocode.lon),
      };
    },
  },

  methods: {
    mapClick(event) {
      this.entity.geocode.lat = event.latLng.lat();
      this.entity.geocode.lon = event.latLng.lng();
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
        { name: 'Description', value: this.entity.description, type: 'required' },
        { name: 'Email', value: this.entity.contacts.email, type: 'email' },
      ]);
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      const { entity } = this;
      postFormData.append('title', entity.title);
      postFormData.append('description', entity.description);
      if (entity.address.country) postFormData.append('country', entity.address.country);
      if (entity.address.state) postFormData.append('state', entity.address.state);
      if (entity.address.city) postFormData.append('city', entity.address.city);
      if (entity.address.address) postFormData.append('address', entity.address.address);
      if (entity.address.postal_code) postFormData.append('postal_code', entity.address.postal_code);
      if (entity.address.organisation_name) postFormData.append('organisation_name', entity.address.organisation_name);
      if (entity.contacts.fax) postFormData.append('fax', entity.contacts.fax);
      if (entity.contacts.email) postFormData.append('email', entity.contacts.email);
      if (entity.contacts.phone) postFormData.append('phone', entity.contacts.phone);
      if (entity.contacts.website) postFormData.append('website', entity.contacts.website);
      if (entity.geocode.lat) postFormData.append('lat', entity.geocode.lat);
      if (entity.geocode.lon) postFormData.append('lon', entity.geocode.lon);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}locations`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/content/location/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create location query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?024066fe